































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxDataGrid, DxColumn, } from 'devextreme-vue/data-grid';

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import UsuarioPopup from './UsuarioPopup.vue';
import DialogForm from "@/components/DialogForm.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import { Usuario } from '@/model/Usuario';
import { UsuarioService } from '@/services/UsuarioService';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DialogForm,
    DialogConfirm
  },
})
export default class UsuarioList extends Vue {
  datasource: any = []
  visible: boolean = false;
  visibleConfirm: boolean = false;
  
  nameComponent: string = "UsuarioPopup";
  usuario: any | Usuario = {};
  tituloPopup: string = "Nuevo usuario";
  
  grid: any;
  columns: any = [
    {
      dataField: "Nombre",
      caption: "Nombre",
    },
    {
      dataField: "Login",
      caption: "Login"
    },
    {
      dataField: "Activo",
      caption: "Activo"
    },
    {
      dataField: "Rol",
      caption: "Rol",
      lookup: {
          dataSource: [{Id:0, Value:'Normal'}, {Id:99, Value:'Administrador'}],
          displayExpr: "Value",
          valueExpr: "Id"
      }
    }
  ];
  width: string = "100%";
  height: number = 500;
  headerFilter: any = { visible: true };

  creating: boolean = false;

  usuarioService: UsuarioService = new UsuarioService();

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "add",
        onClick: () => {
          this.onNew();
        }
      }
    },
    {
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        onClick: () => {
          this.loadUsuarios();
        }
      }
    });
  }

  mounted() {

    this.grid = (<any>this.$refs["gridDevextreme"]).instance;
    eventService.on("DialogForm-Close", (obj: any) => {
      this.visible = false;
    });

    eventService.on("UsuarioPopup-Save", (obj: any) => {
      this.visible = false;
      if(this.creating){
        this.newUsuario(obj);
      }else{
        this.updateUsuario(obj);
      }
    });

    eventService.on("DialogConfirm-Cancel", (obj: any) => {
      this.visibleConfirm = false;
      this.usuario = {};
    });

    eventService.on("DialogConfirm-Accept", (obj: any) => {
      this.visibleConfirm = false;
      this.deleteUsuario();
    });
  }

  created(){
    logService.Info("Inicio",".vue - ()");
    this.loadUsuarios();
  }

  destroyed(){
    eventService.off("DialogForm-Close");
    eventService.off("UsuarioPopup-Save");
    eventService.off("DialogConfirm-Cancel");
    eventService.off("DialogConfirm-Accept");
  }

  loadUsuarios(){
    logService.Info("Inicio","UsuarioList.vue - loadUsuarios()");
    eventService.emit("LoadPanel", true);
    this.usuarioService.getAll().then((res) => {
      eventService.emit("LoadPanel", false);
      this.datasource = res;
    })
  }

  newUsuario(newUsuario: Usuario){
    logService.Info("Inicio","UsuarioList.vue - newUsuario()");
    this.usuarioService.insert(newUsuario).then((res) => {
      eventService.emit("LoadPanel", false);
      console.log("Usuario creado");
      this.creating = false;
      toastService.success("Usuario creado correctamente.");
      this.loadUsuarios();
    });
  }

  updateUsuario(updateUsuario: Usuario){
    logService.Info("Inicio","UsuarioList.vue - updateUsuario()");
    this.usuarioService.update(updateUsuario).then((res) => {
      console.log("Usuario modificado");
      this.creating = false;
      toastService.success("Usuario modificado correctamente.");
      this.loadUsuarios();
    });
  }

  deleteUsuario(){
    logService.Info("Inicio","UsuarioList.vue - deleteUsuario()");
    this.usuarioService.deleteById(this.usuario.Id).then(() => {
      console.log("Usuario eliminado");
      toastService.success("Usuario eliminado correctamente.");
      this.loadUsuarios();
    });
  }

  onUnlock(event: any){
    logService.Info("Inicio","UsuarioList.vue - onUnlock()");
    this.usuario = event.data;
    this.usuarioService.desbloquear(this.usuario.Id).then(() => {
      console.log("Usuario desbloqueado");
      toastService.success("Usuario desbloqueado correctamente.");
      this.loadUsuarios();
    });
  }

  onNew(){
    this.visible = true;
    this.creating = true;
    eventService.emit('UsuarioPopup-Open', new Usuario())
  }

  onEdit(event: any){
    this.visible = true;
    eventService.emit('UsuarioPopup-Open', event.data)
  }

  onDelete(event: any){
    this.usuario = event.data;
    this.visibleConfirm = true;
  }
  
}
